import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {
  "title": "Študentske demonstracije? Pha! Prej farsa s smešnim izidom",
  "description": "",
  "published": "2010-05-19T00:00:00.000Z",
  "redirect_from": ["/blog/studentske-demonstracije-pha-prej-farsa-s-smesnim-izidom/swizec/1342"],
  "categories": "Uncategorized",
  "hero": "../../../defaultHero.jpg"
};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p>{`Strah in groza v `}<del parentName="p">{`Las Vegasu`}</del>{` Ljubljani.`}</p>
    <p>{`Približno tako je danes zgledalo, oz. vsaj zvenelo na twitterju.`}</p>
    <p>{`Kaotično. Zmedeno. Prijetno brez cilja in vsake logike.`}</p>
    <p>{`Imeli smo študentske demonstracije proti opresiji nadgroznega državnega aparata!`}</p>
    <p>{`A demonstrirali so pijani dijaki.`}</p>
    <p>{`Imeli smo študentske demonstracije za pravo študentsko stvar!`}</p>
    <p>{`A skup niso spravili niti sence kakega manifesta.`}</p>
    <p>{`Imeli smo bitko in sekla bridka so se jekla proti zlobnim policistom!`}</p>
    <p>{`A vsi so se poskrili že po dobri uri.`}</p>
    <p>{`Imeli smo razbijanje in divjanje po ulicah, da se nas vidi! Da povemo svoje!`}</p>
    <p>{`A par ur zatem so posledice le na 10 metrih pred parlamentom, drugje niti smeti več ni.`}</p>
    <p>{`Imeli smo zavzemanje nadsuper študentskih organizacij za študentsko stvar!`}</p>
    <p>{`A `}<a parentName="p" {...{
        "href": "http://www.facebook.com/pages/19-maj-2010-Sram-me-je-da-sem-student/122899267730285"
      }}>{`študentje`}</a>{` se že `}<a parentName="p" {...{
        "href": "http://www.facebook.com/group.php?gid=112004728842213"
      }}>{`jezno`}</a>{` `}<a parentName="p" {...{
        "href": "http://www.facebook.com/group.php?gid=115050728536417"
      }}>{`zbirajo`}</a>{` in `}<a parentName="p" {...{
        "href": "http://www.facebook.com/group.php?gid=124634080889905"
      }}>{`zahtevajo`}</a>{` `}<a parentName="p" {...{
        "href": "http://www.facebook.com/group.php?gid=124901234203021"
      }}>{`ukinitev`}</a>{` `}<a parentName="p" {...{
        "href": "http://www.facebook.com/group.php?gid=118410654865056"
      }}>{`ŠOS`}</a>{` `}<a parentName="p" {...{
        "href": "http://www.facebook.com/group.php?gid=108658565835490"
      }}>{`in`}</a>{` `}<a parentName="p" {...{
        "href": "http://www.facebook.com/group.php?gid=120662134634976"
      }}>{`ŠOU`}</a>{`.`}</p>
    <p>{`...`}</p>
    <p>{`Jah, takle mamo, študentsko gibanje je le še senca tega kar smo imeli v 70ih. Sicer nisem bil zraven, ampak `}<a parentName="p" {...{
        "href": "http://sl.wikipedia.org/wiki/Manifest_zasedene_Filozofske_fakultete"
      }}>{`Zasedba Filozofske Fakultete `}</a>{`je bilo tako epska, da še zdaj stari Ljubljančani govorijo o tem. Takrat ... to je bilo tisto pravo, tako se te stvari delajo.`}</p>
    <p>{`Ne pa zdaj, neka na pol mafijska organizacija, ki parazitira ljudi katere naj bi ščitila organizira proteste samo in izključno takrat kadar nekdo stopi na prste njenega denarja. Pa čeprav se vsi študentje strinjajo ali pa jim celo dol visi. Potem je pa treba pijano drhal dijaško nahujskat in jo spravit na ceste, da ne bi slučajno bilo preveč očitno za koga dejansko so demonstracije. Ja tako je, po pričevanjih očividcev so bili edini študentje na demonstracijah organizatorji in nekaj lolekov s FDV-ja.`}</p>
    <p>{`Takrat ko so nam pa bone dražili in so jokali in pizdili res vsi študentje kar jih poznam, takrat pa nič. O ne, to pa ne bomo protestirali, še malo bomo probali skrit vso zadevo.`}</p>
    <p>{`Ampak priznam, malo sem pa vseeno ponosen na današnje dogajanje. Cel dopoldan sem se spraševal kaj bi bilo potrebno da sprožimo nekaj pravega, nekaj kar bo vsaj na daleč zgledalo, kot da imamo kaj povedat:`}</p>
    <p>{`Najprej je zgledalo zelo klavrno. Mislim, jao, demonstracije proti državi so se začele popoldan, zato ker za dopoldan niso dobili dovoljenja od države. Wtf? No saj, potem ko se je pa zares začelo dogajat je pa organizator namesto, da bi podprl svoje lutke, stisnil rep med noge in se "distanciral od nasilja".`}</p>
    <p>{`Pa vseeno, dobili smo tole:`}</p>
    <p>{`Nahujskani dijački, ki sami zase ne vejo zakaj so tam. "kdor ne skače ni slovenc" ... čaki kaj? Zakaj že demonstrirate in se tepete s prašiči? Al ste morebiti na fuzbal tekmi?`}</p>
    <p>{`No saj, resnost izgredov se vidi že v tem kako dolgo so trajali in kako daleč so se razširili. Bojim se da Kresalka vseeno ne bo mogla upravičit nakupa tiste vodne pištolce ...`}</p>
    <p>{`Kakorkoli, ponosen sem na študentsko organizacijo in predvsem na svoje kolege študente -`}</p>
    <p><strong parentName="p">{`Dobili smo iskro potrebno za upor proti ŠOU/ŠOS, izkoristimo jo do konca!`}</strong></p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      